import { Helmet } from "react-helmet";
import {
  buildVehicleDetailsBreadcrumbListSchema,
  type DetailsPageType,
} from "./buildVehicleDetailsBreadcrumbListSchema";

export type { DetailsPageType };

type Props = {
  make: string;
  model: string;
  pageType: DetailsPageType;
  paramId: string;
  currentPageName: string;
};

export const SeoBreadcrumbListSchema = ({
  make,
  model,
  pageType,
  paramId,
  currentPageName,
}: Props) => {
  if (
    !pageType ||
    !make ||
    !model ||
    paramId == null ||
    String(paramId).length === 0 ||
    !currentPageName?.trim()
  ) {
    return null;
  }

  const schema = buildVehicleDetailsBreadcrumbListSchema(
    make,
    model,
    pageType,
    paramId,
    currentPageName.trim()
  );

  return (
    <Helmet encodeSpecialCharacters={false}>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};
